/* eslint-disable */
import {
    AccountBalanceWallet,
    OutboundRounded,
    SaveAlt,
    Send,
    Visibility,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
    AlertColor,
    Button,
    Divider,
    Pagination,
    Menu,
    Checkbox,
    FormControlLabel,
    Typography,
    TextField,
    Switch,
    Tooltip,
    IconButton,
} from "@mui/material";
import { PieValueType, pieArcLabelClasses } from "@mui/x-charts";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { GridColumns } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ptBR } from "@mui/x-date-pickers/locales";
import dayjs from "dayjs";
import xlsx from "json-as-xlsx";
import { MouseEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { HeaderPage } from "../../components/Header/HeaderPage";
import PageWrapper from "../../components/PageWrapper";
import { SelectComponent } from "../../components/Select/Select";
import TableDataGrid from "../../components/TableDataGrid";
import Toast from "../../components/Toast";
import ModalResendInvoicesBulk from "../../components/ModalResendInvoicesBulk";
import { useAuth } from "../../contexts/contexts";
import { formatCurrencyToShow } from "../../helpers/currency";
import { api } from "../../services/api";
import BillingDetailsModal from "../CustomerDetailsPage/BillingDetailsModal";
import {
    BillingContainer,
    BillingTable,
    ChartContainer,
    FinancialCard,
    FinancialContainer,
    HeaderFilter,
    FilterFields,
    Info,
    Page,
    PieContainer,
    ContentPagination,
    ContentSelectStatus,
    ContentPie,
    Pie,
    ExportDiv,
    ContentResendInvoices,
    ItemInput,
    ContentFilterHeader,
} from "./styles";

import { Filters, MonthlyBilling } from "./types";
import { TransformDate } from "../../helpers/transformDate";
import { statusChip } from "./config";
import { FilterHeader } from "./FilterHeader";

import { defaultFilter, mbStatus, datesInitials, datesEndInitials } from "./constants";

let idsInvoices: number[] = [];

export function MonthlyBillingReportPage() {
    const [openToast, setOpenToast] = useState<boolean>(false);
    const [toastRequisitionResult, setToastRequisitionResult] =
        useState<AlertColor>();
    const [textToast, setTextToast] = useState("");

    const [loadingResendInvoice, setLoadingResendInvoice] =
        useState<boolean>(false);

    const [titleSendedInvoice, setTitleSendedInvoice] = useState<string>("");
    const [contentSendedInvoice, setContentSendedInvoice] =
        useState<string>("");
    const [viasSended, setViasSended] = useState<string[]>([]);
    const [anchorElVias, setAnchorElVias] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorElVias);

    const [showModalResendInvoices, setShowModalResendInvoices] =
        useState<boolean>(false);

    const [billingSelected, setBillingSelected] =
        useState<BillingsDetailsProps | null>(null);
    const [openBillingDetailsModal, setOpenBillingDetailsModal] =
        useState(false);

    const [billingData, setBillingData] = useState<MonthlyBilling[]>([]);
    const [pieData, setPieData] = useState<PieValueType[]>([
        {
            id: 1,
            value: 1,
            label: "Loading...",
            color: "#bbbbbb",
        },
    ]);
    const [valuesData, setValuesData] = useState<any[]>([
        {
            id: 0,
            label: "carregando...",
            value: 400,
            color: "#bbbbbb",
            bgColor: "#bbbbbb",
        },
    ]);
    const [startDate, setStartDate] = useState<string | null>(datesInitials);
    const [endDate, setEndDate] = useState<string | null>(datesEndInitials);
    const [status, setStatus] = useState<number>(defaultFilter.status ?? 4);
    const [loading, setLoading] = useState<boolean>(false);
    const [unfilledInvoices, setUnfilledInvoices] = useState<boolean>(false);
    const [filters, setFilters] = useState<Filters>(defaultFilter);

    const [totalPage, setTotalPages] = useState<number | null>(null);

    const navigate = useNavigate();

    const { permissions, hasPermissions } = useAuth();

    const handleOpenBillingDetailsModal = (
        detailsBilling: BillingsDetailsProps
    ) => {
        setBillingSelected(detailsBilling);
        setOpenBillingDetailsModal(true);
    };

    const handleCloseBillingDetailsModal = () => {
        setOpenBillingDetailsModal(false);
    };

    const handleChange = debounce(
        (value: string, type: "title" | "content") => {
            if (type === "title") {
                setTitleSendedInvoice(value);
            }

            if (type === "content") {
                setContentSendedInvoice(value);
            }
        },
        500
    );

    // const handleResendInBulkInvoices = async () => {
    //     if (
    //         titleSendedInvoice.length <= 0 ||
    //         contentSendedInvoice.length <= 0
    //     ) {
    //         defaultToast("warning", "Preencha os campos!");
    //         return;
    //     }

    //     try {
    //         setLoadingResendInvoice(true);
    //         const responseResendInBulkInvoices = await api.post(
    //             "monthly-billing/send",
    //             {
    //                 vias: viasSended,
    //                 ids: idsInvoices,
    //                 title: titleSendedInvoice,
    //                 content: contentSendedInvoice,
    //             }
    //         );

    //         if (responseResendInBulkInvoices.status) {
    //             defaultToast("success", "Enviado com sucesso!");
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         defaultToast("error", "Erro ao reenviar faturas!");
    //     } finally {
    //         setLoadingResendInvoice(false);
    //     }
    // };

    const handleSelectVias = (types: "email" | "sms" | "whatsapp") => {
        if (types === "email") {
            const isExistsItem = viasSended.includes("email");
            if (!isExistsItem) {
                setViasSended((oldValue) => [...oldValue, "email"]);
            } else {
                setViasSended((oldValue) =>
                    oldValue.filter((value) => value !== "email")
                );
            }
        } else if (types === "sms") {
            const isExistsItem = viasSended.includes("sms");
            if (!isExistsItem) {
                setViasSended((oldValue) => [...oldValue, "sms"]);
            } else {
                setViasSended((oldValue) =>
                    oldValue.filter((value) => value !== "sms")
                );
            }
        } else if (types === "whatsapp") {
            const isExistsItem = viasSended.includes("whatsapp");
            if (!isExistsItem) {
                setViasSended((oldValue) => [...oldValue, "whatsapp"]);
            } else {
                setViasSended((oldValue) =>
                    oldValue.filter((value) => value !== "whatsapp")
                );
            }
        }
    };

    useEffect(() => {
        if (
            hasPermissions("relatorio.mensalidade.visualizar") === false &&
            permissions.length > 0
        ) {
            navigate("/Error");
        }
    }, [permissions]);

    const handleChangeDate = (
        value: dayjs.Dayjs | null,
        type: "startDate" | "endDate"
    ) => {
        if (!value || !value.isValid()) {
            return;
        }

        const dateFormated = value.format("YYYY-MM-DD");

        if (type === "endDate") {
            setEndDate(dateFormated);
        } else {
            setStartDate(dateFormated);
        }

        setFilters((prevState) => ({
            ...prevState,
            [type]: dateFormated,
        }));
    };

    const handleClick = () => {
        console.log("TESTANDO");
    };

    const resolveDateParam = (
        preferredDate: string | null | undefined,
        fallbackDate: string | null | undefined
    ) => {
        const preferred = preferredDate?.substring(0, 10);
        if (preferred && dayjs(preferred).isValid()) {
            return preferred;
        }

        const fallback = fallbackDate?.substring(0, 10);
        if (fallback && dayjs(fallback).isValid()) {
            return fallback;
        }

        return datesInitials;
    };

    const buildSearchParams = (
        page: number | string,
        currentStartDate: string | null,
        currentEndDate: string | null,
        activeFilters: Filters,
        onlyActivate = false
    ) => {
        const start = resolveDateParam(
            currentStartDate,
            activeFilters.startDate
        );
        const end = resolveDateParam(currentEndDate, activeFilters.endDate);

        const params = new URLSearchParams();
        params.set("page", String(Number(page) || 1));
        params.set("start_date", start);
        params.set("end_date", end);

        if (onlyActivate) {
            params.set("only_activate", "true");
        }

        if (activeFilters.filterType && activeFilters.filterValue) {
            params.set(
                activeFilters.filterType,
                activeFilters.filterValue.trim()
            );
        }

        return params;
    };

    const handleSearchReportsMonths = async (
        currentDateReference: string | null = datesInitials,
        currentDueDate: string | null = datesInitials,
        statusReports = status,
        unfilledInvoice = unfilledInvoices,
        page = 1,
        onlyPagination = false,
        activeFilters: Filters = filters
    ) => {
        if (!currentDateReference && !currentDueDate) {
            setOpenToast(true);
            setToastRequisitionResult("warning");
            setTextToast("Preencha os campos de datas");

            return;
        }

        const queryParams = buildSearchParams(
            page,
            currentDateReference,
            currentDueDate,
            activeFilters,
            unfilledInvoice
        );

        setFilters((prev) => ({
            ...prev,
            ...activeFilters,
            startDate: queryParams.get("start_date") || datesInitials,
            endDate: queryParams.get("end_date") || datesEndInitials,
            status: statusReports,
        }));
        setStartDate(queryParams.get("start_date"));
        setEndDate(queryParams.get("end_date"));

        setLoading(true);

        if (onlyPagination) {
            try {
                const responseMonthlyBilling = await api.get(
                    `/v2/monthlybilling/list/${statusReports}?${queryParams.toString()}`
                );

                if (responseMonthlyBilling.status) {
                    setBillingData(
                        responseMonthlyBilling.data.response.data.data
                    );
                    setTotalPages(
                        responseMonthlyBilling.data.response.data.last_page
                    );
                    setLoading(false);
                }
            } catch (error) {
                console.error(error);
                setOpenToast(true);
                setToastRequisitionResult("error");
                setTextToast("Erro ao buscar dados");
            } finally {
                setLoading(false);
            }
        } else {
            setPieData([
                {
                    id: 0,
                    value: 1,
                    label: "carregando...",
                    color: "#e1e1e1",
                },
            ]);
            setValuesData([
                {
                    id: 1,
                    label: "carregando...",
                    value: 0,
                    color: "#202020",
                    bgColor: "#e1e1e1",
                },
            ]);

            const responseDashboard = api.get(
                `/v2/monthlybilling/dashboard?${queryParams.toString()}`
            );

            const responseMonthlyBilling = api.get(
                `/v2/monthlybilling/list/${statusReports}?${queryParams.toString()}`
            );

            Promise.all([responseDashboard, responseMonthlyBilling])
                .then((response) => {
                    if (response[0].status) {
                        const { status } = response[0].data.response;
                        const { amount } = response[0].data.response;

                        setPieData([
                            {
                                id: 0,
                                value: status?.is_opening || 0,
                                label: "Abertas",
                                color: "#bbbbbb",
                            },
                            {
                                id: 1,
                                value: status?.is_paid || 0,
                                label: "Pagas",
                                color: "var(--secondary)",
                            },
                            {
                                id: 2,
                                value: status?.is_closing || 0,
                                label: "Fechadas",
                                color: "var(--primary)",
                            },
                            {
                                id: 3,
                                value: status?.is_delayed || 0,
                                label: "Atrasadas",
                                color: "#de5d2a",
                            },
                        ]);
                        const newValueData = [
                            {
                                id: 1,
                                label: "Em Aberto",
                                value: amount.open,
                                color: "#202020",
                                bgColor: "#e7e7e7",
                                total: status.is_opening,
                            },
                            {
                                id: 2,
                                label: "Fechadas",
                                value: amount.closing,
                                color: "var(--primary)",
                                bgColor: "#d5e1ee",
                                total: status.is_closing,
                            },
                            {
                                id: 3,
                                label: "Atrasadas",
                                value: amount.delayed,
                                color: "#de551f",
                                bgColor: "#f4e2db",
                                total: status.is_delayed,
                            },
                            {
                                id: 4,
                                label: "Recebidos",
                                value: amount.paid,
                                color: "var(--secondary)",
                                bgColor: "#dff1df",
                                total: status.is_paid,
                            },
                        ];
                        newValueData.push({
                            id: 5,
                            label: "Total",
                            value: amount.total,
                            color: "#fff",
                            bgColor: "var(--primary)",
                            total: newValueData.reduce(
                                (acc, curr) => Number(acc) + Number(curr.total),
                                0
                            ),
                        });
                        setValuesData(newValueData);
                    }

                    if (response[1].status) {
                        idsInvoices = response[1].data.response.ids;
                        setBillingData(response[1].data.response.data.data);
                        setTotalPages(response[1].data.response.data.last_page);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setOpenToast(true);
                    setToastRequisitionResult("error");
                    setTextToast("Erro ao buscar dados");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const handleClearFilters = () => {
        setFilters(defaultFilter);
        setStartDate(datesInitials);
        setEndDate(datesEndInitials);
        setStatus(defaultFilter.status ?? 4);
        setUnfilledInvoices(false);
        handleSearchReportsMonths(
            datesInitials,
            datesEndInitials,
            defaultFilter.status ?? 4,
            false,
            1,
            false,
            defaultFilter
        );
    };

    const handleFilterHeaderSearch = (nextFilters: Filters) => {
        const nextStatus = nextFilters.status ?? status;
        const nextStartDate = resolveDateParam(
            nextFilters.startDate,
            startDate
        );
        const nextEndDate = resolveDateParam(nextFilters.endDate, endDate);

        setFilters({
            ...nextFilters,
            startDate: nextStartDate,
            endDate: nextEndDate,
            status: nextStatus,
        });
        setStatus(nextStatus);
        setStartDate(nextStartDate);
        setEndDate(nextEndDate);

        handleSearchReportsMonths(
            nextStartDate,
            nextEndDate,
            nextStatus,
            unfilledInvoices,
            1,
            false,
            {
                ...nextFilters,
                startDate: nextStartDate,
                endDate: nextEndDate,
                status: nextStatus,
            }
        );
    };

    const [period, setPeriod] = useState<number>(3);
    const [isExporting, setIsExporting] = useState(false);

    async function exportData() {
        const exportStartDate = resolveDateParam(startDate, filters.startDate);
        const exportEndDate = resolveDateParam(endDate, filters.endDate);

        if (!exportStartDate || !exportEndDate) {
            setOpenToast(true);
            setToastRequisitionResult("warning");
            setTextToast("Selecione o período para exportar");
            return;
        }

        const periodLabel = `${dayjs(exportStartDate).format(
            "DD/MM/YYYY"
        )} - ${dayjs(exportEndDate).format("DD/MM/YYYY")}`;

        try {
            setIsExporting(true);

            const queryParams = buildSearchParams(
                1,
                exportStartDate,
                exportEndDate,
                {
                    ...filters,
                    startDate: exportStartDate,
                    endDate: exportEndDate,
                    status,
                },
                unfilledInvoices
            );

            const responseDashboard = await api.get(
                `/v2/monthlybilling/dashboard?${queryParams.toString()}`
            );

            const { status: statusCounts, amount } =
                responseDashboard.data.response;

            const exportRows = [
                {
                    date: periodLabel,
                    status: "abertas",
                    total: statusCounts?.is_opening || 0,
                    amount: amount?.open || 0,
                },
                {
                    date: periodLabel,
                    status: "fechadas",
                    total: statusCounts?.is_closing || 0,
                    amount: amount?.closing || 0,
                },
                {
                    date: periodLabel,
                    status: "atrasadas",
                    total: statusCounts?.is_delayed || 0,
                    amount: amount?.delayed || 0,
                },
                {
                    date: periodLabel,
                    status: "pagas",
                    total: statusCounts?.is_paid || 0,
                    amount: amount?.paid || 0,
                },
                {
                    date: periodLabel,
                    status: "total",
                    total:
                        Number(statusCounts?.is_opening || 0) +
                        Number(statusCounts?.is_closing || 0) +
                        Number(statusCounts?.is_delayed || 0) +
                        Number(statusCounts?.is_paid || 0),
                    amount: amount?.total || 0,
                },
            ];

            xlsx(
                [
                    {
                        sheet: "Projecao",
                        columns: [
                            { label: "periodo", value: "date" },
                            { label: "status", value: "status" },
                            { label: "quantidade", value: "total" },
                            {
                                label: "valor",
                                value: (row: any) =>
                                    `R$ ${formatCurrencyToShow(row.amount)}`,
                            },
                        ],
                        content: exportRows,
                    },
                ],
                {
                    fileName: `report-monthly-billing-${exportStartDate}_a_${exportEndDate}`,
                    extraLength: 3,
                    writeMode: "writeFile",
                    writeOptions: {},
                }
            );

            const reportParams = new URLSearchParams();
            reportParams.set("start_date", exportStartDate);
            reportParams.set("end_date", exportEndDate);

            const responseReport = await api.get(
                `/v2/monthlybilling/report?${reportParams.toString()}`
            );

            setOpenToast(true);
            setToastRequisitionResult("success");
            setTextToast(
                responseReport.data.response ||
                    `Exportação do período ${periodLabel} gerada com sucesso`
            );
        } catch (error) {
            console.error(error);
            setOpenToast(true);
            setToastRequisitionResult("error");
            setTextToast("Erro ao exportar o período selecionado");
        } finally {
            setIsExporting(false);
        }
    }

    // useEffect(() => {
    //     api.get("/v2/monthlybilling/period/" + period)
    //         .then((response) => {
    //             const xData = response.data.response.map(
    //                 (item: any) => item.competition_date
    //             );


    //             const percent_open: number[] = [];
    //             const percent_closing: number[] = [];
    //             const percent_paid: number[] = [];
    //             const percent_delayed: number[] = [];
    //             const percent_no_peding: number[] = [];

    //             response.data.response.forEach((item: any) => {
    //                 percent_open.push(parseInt(item.percent_opened));
    //                 percent_closing.push(parseInt(item.percent_closing));
    //                 percent_paid.push(parseInt(item.percent_paid));
    //                 percent_delayed.push(parseInt(item.percent_delayed));
    //                 percent_no_peding.push(parseInt(item.percent_no_pending));
    //             });

    //             const result = {
    //                 percent_open: percent_open.reverse(),
    //                 percent_closing: percent_closing.reverse(),
    //                 percent_paid: percent_paid.reverse(),
    //                 percent_delayed: percent_delayed.reverse(),
    //                 percent_no_peding: percent_no_peding.reverse(),
    //             };

    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         });
    // }, [period]);

    const canSendedInvoices =
        titleSendedInvoice.length > 0 && contentSendedInvoice.length > 0;

    const columns: GridColumns = [
        {
            field: "customer_name",
            headerName: "Cliente",
            width: 150,
            flex: 1.5,
            valueGetter: (params) =>
                `${params.row.customer_name ?? "(formulário não preenchido)"}`,
        },
        {
            field: "holder_name",
            headerName: "Titular",
            width: 150,
            flex: 2,
            valueGetter: (params) => `${params.row.holder_name ?? "-"}`,
        },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            flex: 1,
            valueGetter: (params) => `${params.row.status_id}`,
            renderCell: (params) => (
                <div>
                    <span>{statusChip(params.row.status_id)}</span>
                </div>
            ),
        },

        {
            field: "date_reference",
            headerName: "Data de Referencia",
            width: 50,
            flex: 1,
            align: "center",
            valueGetter: (params) =>
                `${String(params.row.date_reference).split("-")[1]}/${
                    String(params.row.date_reference).split("-")[0]
                }`,
        },
        {
            field: "due_date",
            headerName: "Data de Vencimento",
            width: 50,
            flex: 1,
            align: "center",
            valueGetter: (params) => `${TransformDate(params.row.due_date)}`,
        },
        {
            field: "value",
            headerName: "Valor",
            width: 150,
            flex: 1,
            valueGetter: (params) => `${params.row.status_id}`,
            renderCell: (params) => (
                <div>
                    <span>
                        R$ {formatCurrencyToShow(params.row.total_amount)}
                    </span>
                </div>
            ),
        },
        {
            field: "action",
            headerName: "Ações",
            width: 150,
            flex: 1,
            headerAlign: "right",
            align: "right",
            disableExport: true,
            renderCell: (params) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row-reverse",
                    }}
                >
                    <Tooltip
                        title="Visualizar fatura"
                        onClick={() =>
                            handleOpenBillingDetailsModal(params.row)
                        }
                    >
                        <IconButton>
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                    {/* eslint-disable-next-line */}
                    <a
                        href={
                            params.row.customer_id
                                ? `/comercial/customers/customerDetail?id=${params.row.customer_id}`
                                : `/comercial/proposal/proposalDetails?id=${params.row.proposal_id}`
                        }
                        style={{
                            marginTop: 5,
                            textDecoration: "none",
                            color: params.row.customer_id
                                ? "var(--secondary)"
                                : "var(--primary)",
                        }}
                    >
                        <Tooltip
                            title={
                                params.row.customer_id
                                    ? "ir para cliente"
                                    : "ir para proposta"
                            }
                        >
                            <OutboundRounded />
                        </Tooltip>
                    </a>
                </div>
            ),
        },
    ];

    useEffect(() => {
        handleClearFilters();
    }, []);

    return (
        <PageWrapper>
            <BillingContainer>
                <Page>
                    <div style={{ padding: "20px 40px 0px 40px" }}>
                        <HeaderPage
                            title="Relatórios de Faturas"
                            subtitle="Relatórios geral de faturas mensais"
                            icon={
                                <AccountBalanceWallet sx={{ color: "#fff" }} />
                            }
                        />
                    </div>
                    <HeaderFilter>
                        <FilterFields>
                            <div className="filter-field">
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    localeText={
                                        ptBR.components.MuiLocalizationProvider
                                            .defaultProps.localeText
                                    }
                                    adapterLocale="pt-br"
                                >
                                    <DatePicker
                                        label="Data inicial"
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}
                                        value={startDate ? dayjs(startDate) : null}
                                        onChange={(value) =>
                                            handleChangeDate(value, "startDate")
                                        }
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="filter-field">
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    localeText={
                                        ptBR.components.MuiLocalizationProvider
                                            .defaultProps.localeText
                                    }
                                    adapterLocale="pt-br"
                                >
                                    <DatePicker
                                        label="Data final"
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                            },
                                        }}
                                        value={endDate ? dayjs(endDate) : null}
                                        onChange={(value) =>
                                            handleChangeDate(value, "endDate")
                                        }
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="filter-field">
                                <SelectComponent
                                    label="Status da listagem"
                                    fullWidth
                                    items={mbStatus}
                                    value={status}
                                    name="status"
                                    onChange={(e) => {
                                        const nextStatus = Number(
                                            e.target.value
                                        );
                                        setStatus(nextStatus);
                                        setFilters((prev) => ({
                                            ...prev,
                                            status: nextStatus,
                                        }));
                                    }}
                                />
                            </div>
                            <FormControlLabel
                                className="filter-field filter-field--switch"
                                control={
                                    <Switch
                                        checked={unfilledInvoices}
                                        onChange={(event) =>
                                            setUnfilledInvoices(
                                                event.target.checked
                                            )
                                        }
                                    />
                                }
                                label="Apenas com instalações parceladas"
                            />
                        </FilterFields>
                        <FilterHeader
                            handleSearch={handleFilterHeaderSearch}
                            handleClearFilter={handleClearFilters}
                            currentFilter={{
                                ...filters,
                                startDate: startDate ?? datesInitials,
                                endDate: endDate ?? datesEndInitials,
                                status,
                            }}
                        />
                    </HeaderFilter>
                    <Info>
                        Busque faturas pelo vencimento no período (ex.: 01/07 a
                        10/07). A listagem abaixo respeita o status selecionado
                        (use &quot;Todos&quot; para ver todos os status). A
                        exportação inclui todos os dados do período.
                    </Info>

                    <ChartContainer>
                        <FinancialContainer className="flexing">
                            <h3>
                                Projeção de valores das mensalidades por período
                                selecionado
                            </h3>
                            <ExportDiv>
                                <LoadingButton
                                    color="success"
                                    variant="contained"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                    size="small"
                                    loading={isExporting}
                                    onClick={() => exportData()}
                                >
                                    <SaveAlt
                                        fontSize="small"
                                        sx={{
                                            marginRight: "5px",
                                        }}
                                    />
                                    <span>Exportar</span>
                                </LoadingButton>
                            </ExportDiv>
                            {valuesData.length > 1 &&
                                valuesData.map((item, i) => {
                                    return (
                                        <FinancialCard
                                            key={String(i)}
                                            style={{
                                                color: item.color,
                                                backgroundColor:
                                                    item.bgColor ?? "#fff",
                                            }}
                                        >
                                            <div>
                                                <span>{item.label}</span>
                                                <span> - {item.total}</span>
                                            </div>
                                            <span>
                                                R$
                                                {formatCurrencyToShow(
                                                    item.value
                                                )}
                                            </span>
                                        </FinancialCard>
                                    );
                                })}
                            <span style={{ fontSize: "10pt" }}>
                                * estas projeções de valores podem váriar
                                confome o tempo.
                            </span>
                        </FinancialContainer>
                        <PieContainer className="flexing">
                            <h3>Gráfico de status das faturas</h3>
                            <Divider />
                            <ContentPie>
                                <Pie
                                    series={[
                                        {
                                            data: pieData,
                                            innerRadius: 180,
                                            outerRadius: 20,
                                            paddingAngle: 1,
                                            cornerRadius: 5,
                                            arcLabel: (item) =>
                                                `${item.label} (${item.value})`,
                                            arcLabelMinAngle: 45,
                                        },
                                    ]}
                                    width={500}
                                    height={400}
                                    sx={{
                                        [`& .${pieArcLabelClasses.root}`]: {
                                            fill: "white",
                                            fontWeight: "bold",
                                            fontSize: "15px",
                                        },
                                        padding: "30px",
                                    }}
                                />
                            </ContentPie>
                        </PieContainer>
                    </ChartContainer>
                    {/* <ContentGraph>
                        <h3 style={{ margin: 0 }}>
                            Percentual % de faturas por período
                        </h3>
                        <SelectComponent
                            label="Período"
                            size={13}
                            items={mbPeriod}
                            value={period}
                            name="period"
                            onChange={(e) => {
                                setPeriod(e.target.value);
                            }}
                        />
                        <LineChart
                            xAxis={[
                                {
                                    data: monthlyBillingDataLineX ?? arrayMock,
                                    scaleType: "point",
                                    label: "Período em meses",
                                },
                            ]}
                            yAxis={[
                                {
                                    max: 100,
                                    min: 0,
                                    label: "Percentual %",
                                    valueFormatter: (item) => item + "%",
                                },
                            ]}
                            series={[
                                {
                                    data:
                                        monthlyBillingPercent?.percent_open ??
                                        arrayMock,
                                    color: "gray",
                                    label: "Aberto",
                                    valueFormatter: (item) => item + "%",
                                },
                                {
                                    data:
                                        monthlyBillingPercent?.percent_closing ??
                                        arrayMock,
                                    color: "#172b4d",
                                    label: "Fechado",
                                    valueFormatter: (item) => item + "%",
                                },
                                {
                                    data:
                                        monthlyBillingPercent?.percent_paid ??
                                        arrayMock,
                                    color: "green",
                                    label: "Pago",
                                    valueFormatter: (item) => item + "%",
                                },
                                {
                                    data:
                                        monthlyBillingPercent?.percent_delayed ??
                                        arrayMock,
                                    color: "#de551f",
                                    label: "Atrasado",
                                    valueFormatter: (item) => item + "%",
                                },
                                {
                                    data:
                                        monthlyBillingPercent?.percent_no_peding ??
                                        arrayMock,
                                    color: "lightgreen",
                                    label: "Sem pendencia",
                                    valueFormatter: (item) => item + "%",
                                },
                            ]}
                            margin={{ top: 50, bottom: 50 }}
                        />
                    </ContentGraph> */}

                    {(status === 3 || status === 2) && (
                    <ContentFilterHeader>
                        <ContentSelectStatus>
                                <ContentResendInvoices>
                                    <Button
                                        variant="contained"
                                        onClick={(
                                            event: MouseEvent<HTMLButtonElement>
                                        ) => {
                                            setAnchorElVias(event.currentTarget);
                                        }}
                                    >
                                        Reenviar faturas em massa &nbsp;
                                        <Send />
                                    </Button>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorElVias}
                                        open={open}
                                        onClose={() => setAnchorElVias(null)}
                                        MenuListProps={{
                                            "aria-labelledby": "basic-button",
                                        }}
                                        PaperProps={{
                                            style: {
                                                width: "400px",
                                            },
                                        }}
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            align="center"
                                        >
                                            Modos de envio
                                        </Typography>
                                        <Divider />
                                        <div
                                            style={{
                                                marginLeft: "1rem",
                                            }}
                                            onChange={() =>
                                                handleSelectVias("email")
                                            }
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="email"
                                                        checked={viasSended.includes(
                                                            "email"
                                                        )}
                                                    />
                                                }
                                                label="Email"
                                            />
                                        </div>
                                        <div
                                            style={{
                                                marginLeft: "1rem",
                                            }}
                                            onChange={() => handleSelectVias("sms")}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="sms"
                                                        checked={viasSended.includes(
                                                            "sms"
                                                        )}
                                                    />
                                                }
                                                label="Sms"
                                            />
                                        </div>
                                        <div
                                            style={{
                                                marginLeft: "1rem",
                                            }}
                                            onChange={() =>
                                                handleSelectVias("whatsapp")
                                            }
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="whatsapp"
                                                        checked={viasSended.includes(
                                                            "whatsapp"
                                                        )}
                                                    />
                                                }
                                                label="Whatsapp"
                                            />
                                        </div>
                                        <Divider />
                                        <ItemInput>
                                            <TextField
                                                label="Título"
                                                size="small"
                                                variant="outlined"
                                                onChange={(event) =>
                                                    handleChange(
                                                        event.target.value,
                                                        "title"
                                                    )
                                                }
                                                sx={{
                                                    width: "100%",
                                                }}
                                            />
                                        </ItemInput>
                                        <ItemInput>
                                            <TextField
                                                label="Message"
                                                size="small"
                                                variant="outlined"
                                                multiline
                                                rows={2}
                                                placeholder="Digite uma mensagem curta"
                                                onChange={(event) =>
                                                    handleChange(
                                                        event.target.value,
                                                        "content"
                                                    )
                                                }
                                                sx={{
                                                    width: "100%",
                                                }}
                                            />
                                        </ItemInput>
                                        <Divider />
                                        <ItemInput>
                                            <LoadingButton
                                                variant="contained"
                                                fullWidth
                                                onClick={() =>
                                                    setShowModalResendInvoices(true)
                                                }
                                                loading={loadingResendInvoice}
                                                disabled={!canSendedInvoices}
                                            >
                                                Enviar
                                            </LoadingButton>
                                        </ItemInput>
                                    </Menu>
                                </ContentResendInvoices>
                            </ContentSelectStatus>
                    </ContentFilterHeader>
                    )}

                    <BillingTable>
                        <TableDataGrid
                            columns={columns}
                            rows={billingData}
                            loading={loading}
                            hideFooterPagination
                            hideFilter
                            hideColumnMenu
                        />
                    </BillingTable>
                    {totalPage && (
                        <ContentPagination>
                            <Pagination
                                count={totalPage}
                                color="primary"
                                onChange={(event: any) =>
                                    handleSearchReportsMonths(
                                        startDate,
                                        endDate,
                                        status,
                                        unfilledInvoices,
                                        event.target.textContent,
                                        true
                                    )
                                }
                                hideNextButton
                                hidePrevButton
                            />
                        </ContentPagination>
                    )}
                </Page>

                <BillingDetailsModal
                    openBillingDetailsModal={openBillingDetailsModal}
                    handleCloseBillingDetailsModal={
                        handleCloseBillingDetailsModal
                    }
                    currentBillingDetails={billingSelected}
                    handleClick={handleClick}
                    setOpenBillingDetailsModal={setOpenBillingDetailsModal}
                />

                <ModalResendInvoicesBulk
                    setAnchorElVias={setAnchorElVias}
                    title={titleSendedInvoice}
                    setTitle={setTitleSendedInvoice}
                    content={contentSendedInvoice}
                    setContent={setContentSendedInvoice}
                    idsMonthlyBilling={idsInvoices}
                    vias={viasSended}
                    setVisible={setShowModalResendInvoices}
                    visible={showModalResendInvoices}
                />

                <Toast
                    open={openToast}
                    onClose={() => setOpenToast(false)}
                    severity={toastRequisitionResult}
                    text={textToast}
                />
            </BillingContainer>
        </PageWrapper>
    );
}
